import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { TypesModel } from 'common/models/page-models/types/types-data-model';
import { TypesGridMetaModel } from 'common/models/page-models/types/types-grid-meta-model';
import { TypesListingModel } from 'common/models/page-models/types/types-grid-model';
import { TypesGridDataService } from 'common/services/data-services/admin/types/types-grid-data.services';

@Injectable({
  providedIn: 'root',
})
export class TypesGridWidgetService extends GridWidgetService<
  TypesModel,
  TypesListingModel
> {
  constructor(
    protected override ds: TypesGridDataService,
    protected systemService: SystemService
  ) {
    super(ds);
  }

  createQueryParams(queryParam): GridParams {
    for (const key in queryParam) {
      this.queryparm[key] = queryParam[key];
    }
    return this.queryparm;
  }

  getMetaModel(): MetaModel {
    const meta = new TypesGridMetaModel().getMetaModel();
    return meta;
  }


}
